import React, { useEffect, useState, useCallback } from 'react'
import FilterActiveIcon from '../icons/filteractiveicon'
import FilterIcon from '../icons/filtericon'
import service from '../services';
import Loader from "../component/loader";
import serachIcon from './../assets/images/search.svg'


import moment from 'moment'

//Redux Connect
import { useSelector } from 'react-redux';
import { ActCreators } from '../redux/bindActionCretor'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useHistory } from 'react-router-dom';

//react-paginate import 
import ReactPaginate from "react-paginate";
import _ from 'lodash';



let sub;
let typeFilterList = []
let statusFilterList = []
let highlightFormatList = []
let highlightTypeList = []

const mapDispatchToProps = dispatch => {
	return bindActionCreators(ActCreators, dispatch)
};

function HighlightTable(props) {
	const history = useHistory();

	const _HighlightList = useSelector(state => state.HighlightList)
	const [, updateState] = React.useState();
	const forceUpdate = React.useCallback(() => updateState({}), []);

	const [apiserve, setApiserve] = useState(new service());
	// const [offset, setOffset] = useState(0)
	// const [perPage, setPerPage] = useState(20)
	const [isAddHighlight, setAddHighlight] = useState(false)
	const [searchFilter, setSearchFilter] = useState({
		filter: '',
		limit: 50,
		page: 1,
	})
	const [updatedAt, setUpdatedAt] = useState(moment.utc().subtract(360, 'minutes'))

	const [totalhighLight, setTotalHighLight] = useState(0)
	const [status, setStatus] = useState([
		{ assign: "Live", list: 1, value: false },
		{ assign: "Disable", list: 2, value: false },
	])
	const [highlighType, setHighlighType] = useState([
		{ assign: "All", list: 1, value: false },
		{ assign: "News", list: 2, value: false },
		{ assign: "In The Press", list: 3, value: false },
		{ assign: "Stories", list: 4, value: false },
	])

	const [highlightFormat, sethighlightFormat] = useState([
		{ assign: "all", list: 1, value: false },
		{ assign: "External link", list: 2, value: false },
		{ assign: "Blog Post", list: 3, value: false },
	])
	const [statusData, setStatusData] = useState([])
	const [highLightsData, setHighLightData] = useState([])

	const [highLightsDataforamt, setHighLightDataformat] = useState([])
	const [getAllDetails, setgetAllDetails] = useState([])
	const [pageCount, setpageCount] = useState([])
	const [currentPage, setcurrentPage] = useState(
		{
			perPage: 50, cpage: 0, offset: 0, loaderFlag: false
		}
	)
	// const dispatch = useDispatch(dispatch => bindActionCreators(ActCreators, dispatch));

	useEffect(() => {
		apiserve.sendevent("homePage|featuredHighlight|getList", {})
		eventCall();
		return () => {
			sub.unsubscribe();
			typeFilterList = [];
			statusFilterList = [];
		}
	}, [])

	useEffect(() => {
		var data = {
			page: 1,
			limit: 50,
		}
		if (searchFilter.filter) {
			apiserve.sendevent("homePage|featuredHighlight|getListForTile", searchFilter,data)
		} else apiserve.sendevent("homePage|featuredHighlight|getList",{})
	}, [searchFilter.filter])

	// useEffect(() => { getStatusFilter(offset, perPage) }, [status])
	// useEffect(() => { getHighLightFilter(offset, perPage) }, [highlighType])

	const eventCall = () => {

		sub = apiserve.getevent().subscribe((response) => {
			switch (response.event) {
				case "homePage|featuredHighlight|getList":
					if (!response.error) {
						setgetAllDetails(response.data.docs)

						setTotalHighLight(response.data.totalDocs)
						props.GetHighlightTable(response.data.docs)
						setpageCount(Math.ceil(response.data.totalDocs / currentPage.perPage))
						setcurrentPage({
							...currentPage,
							loaderFlag: false
						})
					} else {
					}
					let currentPages = localStorage.getItem('currentPage')
					if (currentPages) {

						setcurrentPage(
							{
								offset: parseInt(localStorage.getItem("offset")),
								//
								cpage: parseInt(localStorage.getItem("currentPage")),
								perPage: parseInt(localStorage.getItem("perPage"))
							},
							// setPerPage(
							// 	 parseInt(localStorage.getItem("perPage"))
							// ),
							() =>
								getHighLightFilter(currentPage.offset, currentPage.perPage)
						);
					}
					else {
						setcurrentPage({
							offset: 0,
							perPage: 50,
							cpage: 0
						},
							// 	setPerPage(
							// 		10
							// ),
							() =>
								getHighLightFilter(currentPage.offset, currentPage.perPage))
					}
					break;
				case "homePage|featuredHighlight|getListForTile":
					if (!response.error) {
						setTotalHighLight(response.data.totalDocs)
						props.GetHighlightTable(response.data.docs)
						setpageCount(Math.ceil(response.data.totalDocs / currentPage.perPage))
						setcurrentPage({
							...currentPage,
							loaderFlag: false
						})
					} else {
					}
					break;
				// case "homePage|featuredHighlight|getListForTile":
				// 	if (!response.error) {
				// 		setTotalHighLight(response.data.length)
				// 		props.GetHighlightTable(response.data.docs)
				// 	} else {
				// 	}
				// 	break;
			}
		})
	}
	const checkStatus = () => {
		return status.findIndex(e => e.value) !== -1
	}
	const highlighStatus = () => {
		return highlighType.findIndex(e => e.value) !== -1
	}
	const highlighStatusformate = () => {
		return highlightFormat.findIndex(e => e.value) !== -1
	}

	const StatusFilter = (e, i) => {

		let statusArray = Object.assign([], status);
		if (e !== 'clearStatus') statusArray[i].value = e.target.checked
		else statusArray.map(e => {
			e.value = false;
			return e
		})
		setStatus(statusArray)
		getStatusFilter(currentPage.offset, currentPage.perPage)
	}

	const handlePageClick = (e) => {
         const selectedPage = e.selected;
		const offset = selectedPage + 1;
		setcurrentPage({
			...currentPage,
			cpage: selectedPage,
			offset: offset,
			loaderFlag: false
		})
		localStorage.setItem('currentPage', selectedPage)
		localStorage.setItem('offset', offset)
		localStorage.setItem('perPage', currentPage.perPage)
		getHighLightProgramList(offset, currentPage.perPage);
	};

	const getHighLightProgramList = (skip, limit) => {
         setcurrentPage({
			...currentPage,
			loaderFlag: true
		})
		var data = {}
		// if (statusFilterList && statusFilterList.length) {
		// 	data.status = statusFilterList;
		// }
	if (statusData && statusData.length) {
				data.status = statusData;
			}
		data.page = skip
		data.limit = limit
		if(searchFilter.filter !== ''){
			data.filter = searchFilter.filter
			 apiserve.sendevent("homePage|featuredHighlight|getListForTile", data)
			}
		else apiserve.sendevent("homePage|featuredHighlight|getList", data)
	};

	const highLightFilter = (e, i) => {
		let highlighArray = Object.assign([], highlighType)
		if (e !== 'clearHighligh') highlighArray[i].value = e.target.checked
		else highlighArray.map(e => {
			e.value = false;
			return e
		})
		setHighlighType(highlighArray)
		getHighLightFilter(currentPage.offset, currentPage.perPage)
	}

	const highLightFilterformate = (e, i) => {
		let highlighArrayformate = Object.assign([], highlightFormat)
		if (e !== 'clearHighligh') highlighArrayformate[i].value = e.target.checked
		else highlighArrayformate.map(e => {
			e.value = false;
			return e
		})
		console.log("eeee",e.value,e.target.value, e.target.checked);

		sethighlightFormat(highlighArrayformate)
		getHighLightFormateFilter(currentPage.offset, currentPage.perPage)
	}

	const getStatusFilter = (skip, limit) => {
		let data = {
			page: 1,
			highlightType: highLightsData != 0 ? highLightsData : ["All", "News", "In The Press", "Stories"],
			highlightFormat: highLightsDataforamt != 0 ? highLightsDataforamt : ["All", "External link", "Blog Post"]
		}
		if (statusFilterList && statusFilterList.length) {
			data.status = statusFilterList
		}
		if (checkStatus()) {
			data.status = []
			status.forEach(e => {
				if (e.value) data.status.push(e.list)
			})
			setStatusData(data.status)
		} else setStatusData([])
		apiserve.sendevent("homePage|featuredHighlight|getList", data);
		eventCall();
	}


	const getHighLightFilter = (skip, limit) => {

		let data = {
			page: 1,
			status: statusData.length != 0 ? statusData : [1, 2],
			highlightFormat: highLightsDataforamt.length != 0 ? highLightsDataforamt : ["All", "External link", "Blog Post"],
			limit: limit
		}
		if (highlighStatus()) {
			data.highlightType = []
			highlighType.forEach(e => {
				if (e.value) data.highlightType.push(e.assign)
			})
			setHighLightData(data.highlightType)
		} else setHighLightData([])

		apiserve.sendevent("homePage|featuredHighlight|getList", data);
		eventCall();
	}

	const getHighLightFormateFilter = (skip, limit) => {

		let data = {
			page: 1,
			status: statusData.length != 0 ? statusData : [1, 2],
			highlightType: highLightsData.length != 0 ? highLightsData : ["All", "News", "In The Press", "Stories"],
			limit: limit
		}
		if (highlighStatusformate()) {
			data.highlightFormat = []
			highlightFormat.forEach(e => {
				if (e.value) data.highlightFormat.push(e.assign)
			})
			setHighLightDataformat(data.highlightFormat)


		} else setHighLightData([])

		apiserve.sendevent("homePage|featuredHighlight|getList", data);
		eventCall();
	}

	const editData = (item) => {
		props.GetHighlightEdit(item)

		history.push({
			pathname: "/highlight-detail-view",
			callFrom: 0
		});
	}

	const addHighlight = () => {
		setAddHighlight(true)
		props.GetHighlightEdit('')
		history.push('/create-highlight');
	}


	const servicesValue = () => {
		let data = {
			page: 1,
			limit: 50,
			filter: searchFilter.filter
		}
		apiserve.sendevent("homePage|featuredHighlight|getList", data);
	}

	const onSearchFilter = (e) => {
		const { name, value } = e.target
		setcurrentPage({
			...currentPage,
			// cpage: 0
		})
		setSearchFilter({
			...searchFilter,
			[name]: value
		})
	}
	return (
		<>
			<div className="dashboard_header with_btn">
				<div className="searchBlock">
					<span>HighLights ({totalhighLight})</span>
					<form onSubmit={e => { e.preventDefault(); }} >
						<input
							type="text"
							placeholder="Search"
							id="searchField"
							name="filter"
							value={searchFilter.filter}
							onChange={onSearchFilter}
						/>
						<button type='button' style={{ pointerEvents: 'none' }}>
							<img src={serachIcon} />
						</button>
						{/* <button type="submit" >
              <img src={serachIcon} />
            </button> */}
					</form>
				</div>
				<div className="button_block admin_user_twoBtn">
					<button onClick={() => addHighlight()} className="head_btn pointer no_border" style={{width:"130px"}}>
						Add Highlight +
					</button>
				</div>
			</div>
			{/* <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
				<p></p>
				<p className="update_date">Last Update: {updatedAt.format("hh:mm A")} MT - {updatedAt.format("MM/DD/YYYY")}</p>
			</div> */}
			<table className="film_list_table striped_table">
				<thead>
					<tr>
						<th>Highlight Title</th>
						<th>
							<span className="d_flex d_flex_align_center">
								{" "}
								Highlight Type
								{highlighStatus() ? <FilterActiveIcon /> : <FilterIcon />}
							</span>
							<div className="tabelData_popup">
								<form>
									<div className="customCheck">
										<div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
											<p className="link" onClick={() => highLightFilter("clearHighligh")}>
												Clear All
											</p>
										</div>


										<div className="customCheckBox">
											<div className="customCheckBox"></div>
											{highlighType.map((item, i) => (
												<div className="customCheckBox">
													<input
														type="checkbox"
														id={"highligh" + item.assign}
														name={"highligh" + item.assign}
														value={item.assign ? true : false}
														checked={item.value ? true : false}
														onClick={e => highLightFilter(e, i)}
													/>
													<label htmlFor={"highligh" + item.assign}>{item.assign}</label>
												</div>
											))}
										</div>
									</div>
								</form>
							</div>
						</th>
						<th>
							<span className="d_flex d_flex_align_center">
								{" "}
								Highlight Format
								{highlighStatusformate() ? <FilterActiveIcon /> : <FilterIcon />}
							</span>
							<div className="tabelData_popup">
								<form>
									<div className="customCheck">
										<div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
											<p className="link" onClick={() => highLightFilterformate("clearHighligh")}>
												Clear All
											</p>
										</div>

										<div className="customCheckBox">

											<div className="customCheckBox"></div>
											{highlightFormat.map((item, i) => (
												<div className="customCheckBox">
													<input
														type="checkbox"
														id={"highligh" + item.assign}
														name={"highligh" + item.assign}
														value={item.assign ? true : false}
														checked={item.value ? true : false}
														onClick={e => highLightFilterformate(e, i)}
													/>
													<label htmlFor={"highligh" + item.assign}>{item.assign}</label>
												</div>
											))}
										</div>
									</div>
								</form>
							</div>
						</th>

						<th>Created Date (MT)</th>
						<th>Last Updated Date (MT)</th>
						<th>
							<span className="d_flex d_flex_align_center">
								Status
								{checkStatus() ? <FilterActiveIcon /> : <FilterIcon />}
							</span>
							<div className="tabelData_popup">
								<form>
									<div className="customCheck">
										<div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
											<p className="link" onClick={() => StatusFilter("clearStatus")}>
												Clear All
											</p>
										</div>

										<div className="customCheckBox">
											{status.map((item, i) => (
												<div className="customCheckBox">
													<input
														type="checkbox"
														id={"status" + item.assign}
														name={`status${item.assign}`}
														value={item.assign}
														checked={Boolean(item.value)}
														onChange={e => StatusFilter(e, i)}
													/>
													<label htmlFor={`status${item.assign}`}>{item.assign}</label>
												</div>
											))}
										</div>
									</div>
								</form>
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					{_HighlightList &&
						_HighlightList.map((item, index) => {
							let C_H = new Date(item.createdAt);
							let U_H = new Date(item.updatedAt);
							return (
								<>
									<tr
										onClick={() => editData(item._id)}
										className={`pointer ${item.status === 2 ? "disable" : ""}`}
									>
										<td style={{ width: "350px" }}>
											<strong>{item.highlightTitle} </strong>
										</td>
										<td style={item.status === "News" ? "" : { width: "250px" }}>
											<p>{item.highlightType}</p>
										</td>
										<td style={item.status === "News" ? "" : { width: "250px" }}>
											<p>{item.highlightFormat}</p>
										</td>
										<td style={{ width: "250px" }}>
											<p>
												{moment(C_H).format("MM/DD/YYYY")} - {moment(C_H).format("h:mm A")}
											</p>
										</td>
										<td style={{ width: "250px" }}>
											<p>
												{moment(U_H).format("MM/DD/YYYY")} - {moment(U_H).format("h:mm A")}
											</p>
										</td>
										<td style={item.status === 2 ? { width: "150px" } : { width: "150px" }}>
											<p>{item.status === 1 ? "Live" : "Disable"}</p>
										</td>
									</tr>
								</>
							);
						})}
				</tbody>
			</table>
			{/* Loader */}
			{currentPage.loaderFlag ? (
				<Loader />
			) : (
				""
			)}
			{getAllDetails.length && getAllDetails ? (
				<div className="custom-pagination">
					<ReactPaginate
						previousLabel={""}
						nextLabel={""}
						breakLabel={"..."}
						breakClassName={"break-me"}
						pageCount={pageCount}
						marginPagesDisplayed={2}
						pageRangeDisplayed={50}
						onPageChange={handlePageClick}
						containerClassName={"pagination"}
						subContainerClassName={"pages pagination"}
						activeClassName={"active"}
						forcePage={currentPage.cpage}
					/>
				</div>
			) : (
				""
			)}
		</>

	);
}

export default connect(null, mapDispatchToProps)(HighlightTable)